export default "__VITE_ASSET__f33b6046__"